import {
  ComposedChart, Bar, Line,
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { PENSION_PAYOUT_YRS } from '../constants/financial';
import { F, FF, P } from '../utils/format';
import { Card } from '../components/Card';
import { Heading } from '../components/Heading';
import { Slider } from '../components/Slider';
import { Toggle } from '../components/Toggle';
import { Table } from '../components/Table';
import { Stack } from '../components/Stack';
import { Shield } from '../components/icons';
import { useApp } from '../hooks/useApp';

export default function Pension() {
  const { s, c, proj, pF, p0, up, upM, setS, tt, fiAge, fiReached, coastAge, budgetMonthly, blendedReturn, realReturn, amor, scen, mcData, mcRunning, runMonteCarlo, showToast, setConfirm, fileRef } = useApp();
  return (
  <Stack>
    <Card glow c={c}>
      <div style={{ fontSize: 11, color: c.muted, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 12 }}>
        DB Pension Formula
      </div>
      <div style={{ display: "flex", alignItems: "baseline", gap: 8, flexWrap: "wrap" }}>
        <span style={{ fontSize: 15, color: c.muted }}>2% ×</span>
        <span style={{ fontSize: 28, fontWeight: 700, color: c.fg }}>{pF.pYrs} yrs</span>
        <span style={{ fontSize: 15, color: c.muted }}>×</span>
        <span style={{ fontSize: 28, fontWeight: 700, color: c.fg }}>{F(pF.av5)}</span>
        <span style={{ fontSize: 15, color: c.muted }}>=</span>
        <span style={{ fontSize: 28, fontWeight: 700, color: c.blue }}>{F(pF.pA)}/yr</span>
      </div>
      <div style={{ fontSize: 13, color: c.muted, marginTop: 14 }}>
        Present Value: <span style={{ color: c.fg, fontWeight: 600 }}>{F(pF.pPV)}</span> · {PENSION_PAYOUT_YRS}yr payout · starts age {s.penAge || 60} · {s.spousal ? "90% (spousal)" : "100% single life"}
      </div>
    </Card>
    <Card c={c} delay={0.05} sx={{ padding: "16px 20px" }}>
      <Toggle l="50% Spousal Survivor Benefit" on={s.spousal} fn={(v) => up("spousal", v)} c={c} />
      <Slider l="Pension Start Age" v={s.penAge || 60} fn={(v) => up("penAge", v)} min={55} max={65} c={c} />
    </Card>
    <Card c={c} delay={0.1}>
      <Heading ic={Shield} c={c}>Pension Accrual</Heading>
      <ResponsiveContainer width="100%" height={260}>
        <ComposedChart data={proj.filter((d) => d.a >= s.startAge)}>
          <CartesianGrid strokeDasharray="3 3" stroke={c.border} />
          <XAxis dataKey="a" tick={{ fontSize: 12, fill: c.muted }} axisLine={{ stroke: c.border }} tickLine={false} />
          <YAxis tickFormatter={F} tick={{ fontSize: 12, fill: c.muted }} axisLine={false} tickLine={false} />
          <Tooltip formatter={(v) => FF(v)} {...tt} />
          <Bar dataKey="pA" fill={c.orange} name="Annual" radius={[4, 4, 0, 0]} />
          <Line type="monotone" dataKey="pPV" stroke={c.blue} strokeWidth={2.5} name="PV" dot={false} />
        </ComposedChart>
      </ResponsiveContainer>
    </Card>
    <Card c={c} delay={0.15}>
      <Table h={["Age", "Years", "Avg Best 5", "Annual", "PV"]} r={proj.filter((d) => d.a >= s.startAge).map((d) => [d.a, d.pYrs, FF(d.av5), FF(d.pA), FF(d.pPV)])} c={c} />
    </Card>
  </Stack>
  );
}
